/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_HeadlineInputs */

const en_backstage_headline = /** @type {(inputs: Backstage_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where Tomorrow works.`)
};

/**
* | output |
* | --- |
* | "Where Tomorrow works." |
*
* @param {Backstage_HeadlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_headline = /** @type {((inputs?: Backstage_HeadlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_HeadlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_headline(inputs)
});